import { createAction, props } from '@ngrx/store';
import { BizProduct } from '../../models/biz-product.model';


export const loadBizProducts = createAction(
  '[Product] Load Biz Products',
  props<{ categoryId: any, subCategoryId: any, specialCategory: any, search: any, page: any, limit: any }>()
);
export const loadBizProductsSuccess = createAction(
  '[Product] Load Biz Products Success',
  props<{ bizProducts:{ currentPage: number, data: BizProduct[], nextPage: number, pageSize: number, prevPage: number, totalItems: number, totalPages: number } }>()
);
export const loadBizProductsFailure = createAction(
  '[Product] Load Biz Products Failure',
  props<{ error: any }>()
);
